
const workflowHistories = [
    {
        "no":"R21081201",
        histories: [
            {
                "phase":"documentCheck",
                "activity": "S10",
                "createdOn":"2021-07-02T08:20:10.000Z",
                "assigneeName":"林小花",
                "action":"退回",
                "description":"評鑑產品1-2補件"
            },
            {
                "phase":"documentCheck",
                "activity": "S20",
                "createdOn":"2021-07-05T08:20:10.000Z",
                "assigneeName":"源天然股份有限公司",
                "action":"同意"
            },
            {
                "phase":"documentCheck",
                "activity": "S10",
                "createdOn":"2021-07-06T08:20:10.000Z",
                "assigneeName":"林小花",
                "action":"退回",
                "description":"評鑑產品1仍需補件"
            },
            {
                "phase":"documentCheck",
                "activity": "S20",
                "createdOn":"2021-07-07T08:20:10.000Z",
                "assigneeName":"源天然股份有限公司",
                "action":"同意"
            },
        ]
    },
    {
        "no":"R21081501",
        histories: [
            {
                "activity": "S10",
                "createdOn":"2021-07-02T08:20:10.000Z",
                "assigneeName":"林小花",
                "action":"退回",
                "description":"評鑑產品1-2補件"
            },
            {
                "activity": "S20",
                "createdOn":"2021-07-05T08:20:10.000Z",
                "assigneeName":"福星食品有限公司",
                "action":"同意"
            },
            {
                "activity": "S10",
                "createdOn":"2021-07-06T08:20:10.000Z",
                "assigneeName":"林小花",
                "action":"同意"
            }
        ]
    },
    {
        "no":"R21081311",
        histories: [
            {
                "activity": "S10",
                "createdOn":"2021-07-02T08:20:10.000Z",
                "assigneeName":"林小花",
                "action":"退回",
                "description":"評鑑產品1-2補件"
            },
            {
                "activity": "S20",
                "createdOn":"2021-07-05T08:20:10.000Z",
                "assigneeName":"福星食品有限公司",
                "action":"同意"
            },
            {
                "activity": "S10",
                "createdOn":"2021-07-06T08:20:10.000Z",
                "assigneeName":"林小花",
                "action":"同意"
            },
            {
                "activity": "S30",
                "createdOn":"2021-07-06T08:20:10.000Z",
                "assigneeName":"林小花",
                "action":"同意"
            }
        ]
    },
    {
        "no":"R21081305",
        histories: [
            {
                "activity": "S10",
                "createdOn":"2021-07-02T08:20:10.000Z",
                "assigneeName":"林小花",
                "action":"退回",
                "description":"評鑑產品1-2補件"
            },
            {
                "activity": "S20",
                "createdOn":"2021-07-05T08:20:10.000Z",
                "assigneeName":"福星食品有限公司",
                "action":"同意"
            },
            {
                "activity": "S10",
                "createdOn":"2021-07-06T08:20:10.000Z",
                "assigneeName":"林小花",
                "action":"同意"
            },
            {
                "activity": "S30",
                "createdOn":"2021-07-06T08:20:10.000Z",
                "assigneeName":"林小花",
                "action":"同意"
            },
            {
                "activity": "S40",
                "createdOn":"2021-07-07T08:20:10.000Z",
                "assigneeName":"吳小草",
                "action":"同意"
            }
        ]
    }
]

export default workflowHistories;